import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  constructor() {}

  private loaderSignal = signal<boolean>(false);

  getLoader(): boolean {
    return this.loaderSignal();
  }

  showLoader(): void {
    // console.log('Showing loader');
    this.loaderSignal.set(true);
  }

  hideLoader(): void {
    // console.log('Hiding loader');
    this.loaderSignal.set(false);
  }
}
